// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-items-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.work-items-modal {
    background: white;
    width: 500px;
    max-width: 90%;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h3 {
    margin: 0;
    color: #2c3e50;
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
}

.work-items-content {
    padding: 20px;
    overflow-y: auto;
}

.add-item-form {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
    background: #f8f9fa;
    padding: 10px;
    border-radius: 4px;
    align-items: center;
}

.add-item-form select,
.add-item-form input {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 3px;
}

.icon-select-btn {
    width: 40px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 18px;
}

.icon-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 5px;
    padding: 10px;
    z-index: 10;
    margin-top: 5px;
}

.icon-dropdown span {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.2s;
}

.icon-dropdown span:hover {
    background: #f0f0f0;
}

.name-input {
    flex: 1 1;
}

.items-list-container {
    margin-top: 20px;
}

.items-list-container ul {
    list-style: none;
    padding: 0;
    margin: 0 0 15px 0;
}

.items-list-container li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-bottom: 1px solid #f0f0f0;
}

.item-icon {
    margin-right: 10px;
}

.item-name {
    font-size: 14px;
    color: #333;
}

.delete-item-btn {
    background: none;
    border: none;
    cursor: pointer;
    opacity: 0.3;
    transition: opacity 0.2s;
    font-size: 14px;
    padding: 5px;
}

.delete-item-btn:hover {
    opacity: 1;
}

.edit-item-btn {
    background: none;
    border: none;
    cursor: pointer;
    opacity: 0.3;
    transition: opacity 0.2s;
    font-size: 14px;
    padding: 5px;
}

.edit-item-btn:hover {
    opacity: 1;
}

.btn-save {
    background: #48bb78;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.btn-save:hover {
    background: #38a169;
}

.btn-cancel {
    background: #f56565;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.btn-cancel:hover {
    background: #e53e3e;
}

.name-input {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.category-group h4 {
    margin: 10px 0 5px;
    color: #666;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/WorkItemsManager.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;AACvB","sourcesContent":[".work-items-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 2000;\r\n}\r\n\r\n.work-items-modal {\r\n    background: white;\r\n    width: 500px;\r\n    max-width: 90%;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n    max-height: 80vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.modal-header {\r\n    padding: 15px 20px;\r\n    border-bottom: 1px solid #eee;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.modal-header h3 {\r\n    margin: 0;\r\n    color: #2c3e50;\r\n}\r\n\r\n.close-btn {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    color: #666;\r\n}\r\n\r\n.work-items-content {\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.add-item-form {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-bottom: 20px;\r\n    background: #f8f9fa;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    align-items: center;\r\n}\r\n\r\n.add-item-form select,\r\n.add-item-form input {\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 3px;\r\n}\r\n\r\n.icon-select-btn {\r\n    width: 40px;\r\n    height: 38px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n}\r\n\r\n.icon-dropdown {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    background: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 5px;\r\n    padding: 10px;\r\n    z-index: 10;\r\n    margin-top: 5px;\r\n}\r\n\r\n.icon-dropdown span {\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.icon-dropdown span:hover {\r\n    background: #f0f0f0;\r\n}\r\n\r\n.name-input {\r\n    flex: 1;\r\n}\r\n\r\n.items-list-container {\r\n    margin-top: 20px;\r\n}\r\n\r\n.items-list-container ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0 0 15px 0;\r\n}\r\n\r\n.items-list-container li {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 8px 10px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.item-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n.item-name {\r\n    font-size: 14px;\r\n    color: #333;\r\n}\r\n\r\n.delete-item-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    opacity: 0.3;\r\n    transition: opacity 0.2s;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n}\r\n\r\n.delete-item-btn:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.edit-item-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    opacity: 0.3;\r\n    transition: opacity 0.2s;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n}\r\n\r\n.edit-item-btn:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.btn-save {\r\n    background: #48bb78;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.btn-save:hover {\r\n    background: #38a169;\r\n}\r\n\r\n.btn-cancel {\r\n    background: #f56565;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.btn-cancel:hover {\r\n    background: #e53e3e;\r\n}\r\n\r\n.name-input {\r\n    flex: 1;\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n}\r\n\r\n.category-group h4 {\r\n    margin: 10px 0 5px;\r\n    color: #666;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.05em;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    padding-bottom: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
